import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import Icon from "../Icon";
import { IconName } from "../Icon/types";

import "./styles.scss";

export const DownloadApps: FC = () => {
  const { t } = useTranslation();

  return (
    <section className="ams-downloads-app">
      <h2>{t("downloadApps", { brand: "VyprVPN" })}</h2>

      <div className="ams-downloads-app__link-list">
        <div className="amd-link-list__column">
          <a
            className="ams-downloads-app__link ams-downloads-app__link-required"
            href="https://www.vyprvpn.com/vpn-apps/vpn-for-windows"
          >
            <Icon className="mr-xs">{"windows" as IconName}</Icon>
            {t("brandForSubject", { brand: "VyprVPN", subject: "Windows" })}
          </a>
          <a
            className="ams-downloads-app__link ams-downloads-app__link-required"
            href="https://www.vyprvpn.com/vpn-apps/vpn-for-mac"
          >
            <Icon className="mr-xs">{"mac" as IconName}</Icon>
            {t("brandForSubject", { brand: "VyprVPN", subject: "Mac" })}
          </a>
        </div>
        <div className="amd-link-list__column">
          <a
            className="ams-downloads-app__link ams-downloads-app__link-required"
            href="https://www.vyprvpn.com/vpn-apps/vpn-for-android"
          >
            <Icon className="mr-xs">{"android" as IconName}</Icon>
            {t("brandForSubject", { brand: "VyprVPN", subject: "Android" })}
          </a>
          <a
            className="ams-downloads-app__link ams-downloads-app__link-required"
            href="https://www.vyprvpn.com/vpn-apps/vpn-for-ios"
          >
            <Icon className="mr-xs">{"ios" as IconName}</Icon>
            {t("brandForSubject", { brand: "VyprVPN", subject: "iOS" })}
          </a>
        </div>
        <div className="amd-link-list__column">
          <span className="ams-downloads-app__wire-guard">
            {t("wireGuard")}
          </span>
        </div>
      </div>
    </section>
  );
};
